import List from "./List";
import ScaleBalanceIcon from "mdi-material-ui/ScaleBalance";

export const SpecialBalanceList = List;
export const SpecialBalanceIcon = ScaleBalanceIcon;
